// Passing configuration.js contents to vuex store
declare global {
  interface Window { configuration: {[id: string]: string} }
}

export default {
  configuration: window.configuration,
}
